import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=6b8dedcf&scoped=true&"
import script from "./Tree.vue?vue&type=script&lang=js&"
export * from "./Tree.vue?vue&type=script&lang=js&"
import style0 from "./Tree.vue?vue&type=style&index=0&id=6b8dedcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8dedcf",
  null
  
)

export default component.exports